import React from 'react';
import { H1, P } from 'components/text';
import { TextField } from 'components/forms';

const Start = () => {
  return (
    <>
      <H1>Let's start with your email address</H1>
      <P>
        You'll use this to log in after your application is approved. We’ll also use this email to contact you about your application status.
      </P>
      <TextField
        name="email"
        label="Email"
        type="email"
        required
      />
    </>
  );
};

export default Start;
